export default {
	themes: {
		light: 'लाइट',
		dark: 'डार्क'
	}
};
